import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

// Phase 1.2.A: Initialize Sentry for error monitoring
// Phase 2.3.B: Enhanced with Core Web Vitals and performance monitoring
Sentry.init({
  dsn: "https://8002d748954cb1426d5aa29f62709b39@o4510467423600640.ingest.us.sentry.io/4510467431530496",
  integrations: [
    Sentry.browserTracingIntegration({
      // Enable automatic instrumentation of React components
      tracingOrigins: ["localhost", "kwyhxlmlrcfacqxlgmlv.supabase.co", /^\//],
      // Track user interactions
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      // Phase 2.3.B: Enhanced replay settings for performance debugging
      networkDetailAllowUrls: ["kwyhxlmlrcfacqxlgmlv.supabase.co"],
      networkCaptureBodies: true,
    }),
  ],
  // Performance Monitoring
  // Phase 2.3.B: Increased sampling for better performance insights
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0, // 20% in prod, 100% in dev
  
  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
  
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  
  // Phase 2.3.B: Track slow transactions
  beforeSend(event, hint) {
    // Log slow transactions to console in development
    if (import.meta.env.DEV && event.type === 'transaction') {
      const duration = event.timestamp && event.start_timestamp 
        ? (event.timestamp - event.start_timestamp) * 1000 
        : 0;
      
      if (duration > 1000) { // Log transactions slower than 1s
        console.warn(`[Sentry] Slow transaction detected: ${event.transaction} (${duration.toFixed(0)}ms)`);
      }
    }
    
    return event;
  },
});

// Phase 2.3.A: Initialize PostHog for user analytics
initAnalytics();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
